import {
  LF_CHANGE_LANGUAGE,
  LF_TOGGLE_MUTE,
  LF_SET_MUTE,
  LF_SET_TEXT_SIZE,
  LF_SET_VOLUME,
  LF_SET_ZOOM,
  LF_TOGGLE_SIDE_MENU_SLIDER_VISIBILITY,
  LF_SELECT_CHARACTER,
  LF_SELECT_CHARACTER_SECTION
} from '../action-types/characters';

export function changeLanguage(languageId) {
  return {
    type: LF_CHANGE_LANGUAGE,
    languageId
  };
}

export function selectCharacterSection(characterSection) {
  return {
    type: LF_SELECT_CHARACTER_SECTION,
    characterSection
  };
}

export function toggleMute() {
  return {
    type: LF_TOGGLE_MUTE
  };
}

export function setMute(muted) {
  return {
    type: LF_SET_MUTE,
    muted
  };
}

export function setVolume(volume) {
  return {
    type: LF_SET_VOLUME,
    volume
  };
}

export function setZoom(zoom) {
  return {
    type: LF_SET_ZOOM,
    zoom
  };
}

export function setTextSize(textSize) {
  return {
    type: LF_SET_TEXT_SIZE,
    textSize
  };
}

export function toggleSideMenuSliderVisibility(show) {
  return {
    type: LF_TOGGLE_SIDE_MENU_SLIDER_VISIBILITY,
    show
  };
}

export function selectCharacter(characterType, characterCase, character) {
  return {
    type: LF_SELECT_CHARACTER,
    characterType,
    characterCase,
    character
  };
}


